/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BadRequestResponse,
  FailureResponseResponse,
  ForbiddenResponse,
  GetAssociationListResponseResponse,
  GetBmAccountingLocationV1AssociationListParams,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * This API will fetch all the associated counters. The counterID parameter shold be minimum of 2digits and it gives you the option to exclude the provided counterID from the response. For example if counterID=00, then it will fetch all the list of associated counters and if counterID=46, then it will exclude counter46 from the response.
 * @summary Get Association List send device token for authorisation
 */
export const getBmAccountingLocationV1AssociationList = (
  params: GetBmAccountingLocationV1AssociationListParams,
  signal?: AbortSignal,
) => {
  return customInstance<GetAssociationListResponseResponse>({
    url: `/bm-accounting-location/v1/association/list`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetBmAccountingLocationV1AssociationListQueryKey = (
  params: GetBmAccountingLocationV1AssociationListParams,
) => {
  return [`/bm-accounting-location/v1/association/list`, ...(params ? [params] : [])] as const;
};

export const getGetBmAccountingLocationV1AssociationListQueryOptions = <
  TData = Awaited<ReturnType<typeof getBmAccountingLocationV1AssociationList>>,
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | FailureResponseResponse
  >,
>(
  params: GetBmAccountingLocationV1AssociationListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBmAccountingLocationV1AssociationList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBmAccountingLocationV1AssociationListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBmAccountingLocationV1AssociationList>>
  > = ({ signal }) => getBmAccountingLocationV1AssociationList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBmAccountingLocationV1AssociationList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBmAccountingLocationV1AssociationListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBmAccountingLocationV1AssociationList>>
>;
export type GetBmAccountingLocationV1AssociationListQueryError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | FailureResponseResponse
>;

/**
 * @summary Get Association List send device token for authorisation
 */
export const useGetBmAccountingLocationV1AssociationList = <
  TData = Awaited<ReturnType<typeof getBmAccountingLocationV1AssociationList>>,
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | FailureResponseResponse
  >,
>(
  params: GetBmAccountingLocationV1AssociationListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBmAccountingLocationV1AssociationList>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBmAccountingLocationV1AssociationListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
